import React from 'react';
import {
  Box,
  Grid,
  Typography,
} from '@mui/material';

const ManagingCommitteeDisplay = ({ members, showContactInfo = true }) => {
  const president = members.find(m => m.position === 'PRESIDENT');
  const officeBearers = members.filter(m => 
    m.position !== 'PRESIDENT' && 
    ['VICE-PRESIDENT', 'SECRETARY', 'JOINT-SECRETARY', 'TREASURER'].includes(m.position)
  );
  const regularMembers = members.filter(m => m.position === 'MEMBER');
  const coOptedMembers = members.filter(m => m.position === 'CO-OPTED MEMBER');
  const allMembers = [...regularMembers, ...coOptedMembers];

  const getPositionDisplay = (position) => {
    const displayMap = {
      'PRESIDENT': 'President',
      'VICE-PRESIDENT': 'Vice President',
      'SECRETARY': 'Secretary',
      'JOINT-SECRETARY': 'Joint Secretary',
      'TREASURER': 'Treasurer',
      'CO-OPTED MEMBER': 'Co-Opted Member',
      'MEMBER': 'Member'
    };
    return displayMap[position] || position;
  };

  const MemberDisplay = ({ member }) => (
    <Box sx={{ textAlign: 'center' }}>
      <Box
        component="img"
        src={member.photoUrl}
        alt={member.name}
        sx={{
          width: '200px',
          height: '250px',
          objectFit: 'contain',
          mb: 2
        }}
        onError={(e) => {
          e.target.src = '/placeholder-avatar.png';
        }}
      />
      <Typography
        variant={member.position === 'PRESIDENT' ? 'h6' : 'subtitle1'}
        sx={{
          color: '#580100',
          fontWeight: 600,
          mb: 1,
          fontSize: member.position === 'PRESIDENT' ? '1.25rem' : '1rem'
        }}
      >
        {member.name}
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{
          color: 'text.secondary',
          textTransform: 'uppercase',
          letterSpacing: '1px',
          fontSize: '0.875rem'
        }}
      >
        {getPositionDisplay(member.position)}
      </Typography>
    </Box>
  );

  return (
    <Box sx={{ width: '100%', py: 6, bgcolor: 'white' }}>
      <Typography 
        variant="h3" 
        component="h2" 
        gutterBottom 
        sx={{ 
          color: '#580100', 
          textAlign: 'center',
          mb: 6,
          fontWeight: 600
        }}
      >
        Managing Committee (2024-2025)
      </Typography>

      {/* President Section */}
      {president && (
        <Box sx={{ mb: 8 }}>
          <Grid container justifyContent="center" spacing={4}>
            <Grid item xs={12} sm={6} md={4}>
              <MemberDisplay member={president} />
            </Grid>
          </Grid>
        </Box>
      )}

      {/* Office Bearers Section */}
      {officeBearers.length > 0 && (
        <Box sx={{ mb: 8 }}>
          <Grid container spacing={4} justifyContent="center">
            {officeBearers.map((member, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <MemberDisplay member={member} />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}

      {/* Members Section (including co-opted members) */}
      {allMembers.length > 0 && (
        <Box>
          <Typography 
            variant="h4" 
            component="h3" 
            gutterBottom 
            sx={{ 
              color: '#580100', 
              textAlign: 'center',
              mb: 4,
              fontWeight: 500
            }}
          >
            Members
          </Typography>
          <Grid container spacing={4} justifyContent="center">
            {allMembers.map((member, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <MemberDisplay member={member} />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default ManagingCommitteeDisplay;
